var map = {
	"./app-down.ts": "57f6",
	"./app-pages.ts": "3f28",
	"./bank-card.ts": "f285",
	"./common.ts": "2bcf",
	"./create-account.ts": "91a0",
	"./funds-management.ts": "4a72",
	"./h5-page.ts": "e289",
	"./help-center-new.ts": "4faf",
	"./help-center.ts": "31e4",
	"./login.ts": "7102",
	"./ocr.ts": "b289",
	"./open-account.ts": "7690",
	"./private-fund.ts": "3b65",
	"./register.ts": "140a0",
	"./risk-assessment.ts": "d1ef",
	"./security-center.ts": "6b1a",
	"./statement.ts": "730e",
	"./test.ts": "6703",
	"./trade-pwd.ts": "05f1",
	"./transfer.ts": "2944",
	"./withdraw.ts": "cff0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35c4";